import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MapState } from '../map.models';

export const getMapState = createFeatureSelector<MapState>('map');

export const getFeatures = createSelector(getMapState, (store) => store.features || []);

export const getSoilAnalysis = createSelector(getMapState, (store) => store.soilAnalysis || []);

export const getCropFieldsLayerEnabled = createSelector(
  getMapState,
  (store) => store.cropFieldsLayerEnabled,
);

export const getSoilAnalysisLayerEnabled = createSelector(
  getMapState,
  (store) => store.soilAnalysisLayerEnabled,
);

export const getBlightLayerEnabled = createSelector(
  getMapState,
  (store) => store.blightLayerEnabled,
);
